export default __webpack_public_path__ + "static/media/framerMotion.dadec6fd.PNG";